import { styled } from 'styled-components';
import { textSmallNormal } from '../../Typography';

export const Container = styled.div`
  display: flex;
  padding: var(--space-150);
  align-items: center;
  gap: var(--space-150);
  border-radius: var(--border-radius-button);
  ${textSmallNormal};
  background: var(--black-200);
  border: 1px solid var(--black-500);

  .content {
    flex: 1;
  }

  color: var(--text-standard-primary);
  svg {
    align-self: flex-start;
    min-height: 28px;
    path {
      color: var(--text-standard-primary);
    }
  }



  &.default {
    color: var(--black-800);
    svg {
      path {
        color: var(--black-800);
      }
    }
  }

  &.positive {
    background: var(--green-100);
    border-color: var(--green-200);
  }

  &.destructive {
    background: var(--red-100);
    border-color: var(--red-200);
  }

  &.warning {
    background: var(--orange-100);
    border-color: var(--orange-200);
  }
`;
